(()=>{
  const initialize=root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const labels=JSON.parse(root.querySelector('[data-quote-labels]').textContent);
    const buttons=[...root.querySelectorAll('[data-industry]')];
    const products=[...root.querySelectorAll('[data-product]')];
    const select=root.querySelector('[data-industry-select]');
    const status=root.querySelector('[data-filter-status]');
    const scroll=el=>el.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    function filter(button){
      const names=button?button.dataset.products.split('|').map(x=>x.trim()):[];
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      products.forEach(p=>p.hidden=!!button&&!names.includes(p.dataset.product));
      status.textContent=button?labels.filtered.replace('[industry]',button.dataset.industry):labels.all;
    }
    buttons.forEach(button=>button.addEventListener('click',()=>{
      select.value=button.dataset.industry;
      filter(button);
      scroll(root.querySelector('.whq-products-section'));
    }));
    select.addEventListener('change',()=>filter(buttons.find(b=>b.dataset.industry===select.value)));
    root.querySelector('[data-reset]').addEventListener('click',()=>filter(null));
    const chosen=[...root.querySelectorAll('[data-quote-product]')];
    const field=root.querySelector('[data-products-field]');
    let previousAuto='';
    chosen.forEach(box=>box.addEventListener('change',()=>{
      const values=chosen.filter(c=>c.checked).map(c=>c.value);
      root.querySelector('[data-shortlist]').textContent=values.join(' • ')||labels.empty;
      const manual=field.value.split('\n').filter(line=>line!==previousAuto).join('\n').trim();
      previousAuto=values.length?'Selected: '+values.join(', '):'';
      field.value=[previousAuto,manual].filter(Boolean).join('\n');
    }));
    const notice=root.querySelector('[data-form-success],[data-form-errors]');
    if(notice){notice.focus({preventScroll:true});scroll(notice);}
  };
  const scan=()=>document.querySelectorAll('[data-wh-quote]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
  document.addEventListener('shopify:section:load',scan);
})();
